import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPillIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M13.9691 1.97918C12.3289 0.338975 9.66963 0.338971 8.02943 1.97917L2.01726 7.99134C0.377059 9.63154 0.377058 12.2908 2.01726 13.931C3.65746 15.5712 6.31675 15.5712 7.95696 13.931L13.9691 7.91887C15.6093 6.27867 15.6093 3.61938 13.9691 1.97918ZM9.01938 2.96912C10.1128 1.87566 11.8857 1.87566 12.9792 2.96913C14.0726 4.06259 14.0726 5.83546 12.9792 6.92892L10.7798 9.12826L6.82004 5.16847L9.01938 2.96912ZM5.83009 6.15842L9.78988 10.1182L6.96701 12.9411C5.87354 14.0346 4.10068 14.0346 3.00721 12.9411C1.91374 11.8476 1.91374 10.0748 3.00721 8.98129L5.83009 6.15842Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPillIconComponent;
